import React, {Component} from 'react'
import ReactApexChart from "react-apexcharts";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";

class PatientChartConnected extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visibleGraphData: 0,
            maxData: 3,
        }
    }

    componentDidMount() {
    }

    render() {



        let chartOptions = {
            legend: {show: this.props.showLegend,horizontalAlign: 'right',position:'top'},
            colors: this.props.colors,
            series: this.props.series,

            chart: {
                background: this.props.backgroundColor,
                group: 'social',
                type: 'line',
                zoom: {
                    enabled: false
                },
                toolbar: {
                    show: false
                },
                stacked:this.props.stacked,
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            stroke: {
                show: true,
                curve: 'smooth',
                lineCap: 'butt',
                colors: undefined,
                width: 2,
                dashArray: 0,
            },
            plotOptions: {
                bar: {
                    columnWidth: '56px',
                    horizontal: false,
                    dataLabels: {
                        position: 'top',
                    },
                }
            },
            dataLabels: {
                enabled: false
            },
            title: {
                text: '',
                align: 'left'
            },
            grid: {
                borderColor: '#fafafa',
                row: {
                    opacity: 0.1
                },
            },
            yaxis: {
                min: 0,
                tickAmount: 5,
                forceNiceScale: false,
                max: this.props.maxY?this.props.maxY:20,
                title: {
                    text: '',
                    style: {
                        fontSize: '15px',
                        fontFamily: 'OpenSan, sans-serif',
                        fontWeight: 300,
                        letterSpacing: '0.35px'
                    }
                },
            },
            xaxis: {
                categories: this.props.xCategories,
                lines: {
                    show: false
                }
            }
        }


        let series=this.props.series


        return(

            <div className={'chart-area'}>
                <div className={'chart-container'}>

                    <ReactApexChart options={chartOptions} series={series} type={"line"} height={this.props.minHeight} width={this.props.minWidth}/>

                </div>
            </div>


        );
    }


}

const PatientChart = compose(
    withTranslation(),
    connect(
    )
)(PatientChartConnected)

export default PatientChart
